import { useRef } from 'react';

import { createRequiredContext } from 'src/context/createRequiredContext';

import { type IBackupDetailsForm } from '../ui';

const [useBackupDetailsContext, BackupDetailsContext] = createRequiredContext<{
  formRef: React.RefObject<{
    submit: (callback: (data: IBackupDetailsForm) => void) => void;
  } | null>;
  onSubmit: (callback: (data: IBackupDetailsForm) => void) => void;
}>();

const BackupDetailsContextProvider = ({ children }: { children: React.ReactNode }) => {
  const formRef = useRef<{
    submit: (callback: (data: IBackupDetailsForm) => void) => void;
  }>(null);

  const onSubmit = (callback: (data: IBackupDetailsForm) => void) => {
    if (formRef.current) formRef.current.submit(callback);
  };

  const value = { formRef, onSubmit };

  return <BackupDetailsContext value={value}>{children}</BackupDetailsContext>;
};

export { useBackupDetailsContext, BackupDetailsContextProvider };
